// Client for the local print bridge running on each warehouse PC.
// The bridge listens on http://localhost:9100 and prints a 40x30mm item label
// on a USB Xprinter when an item is marked received.
//
// Bridge source: D:\ClaudeCodeWorkspace\scripts\ops\print_bridge\

const BRIDGE_URL = 'http://localhost:9100';

export interface ItemLabelPayload {
  sku: string;
  color: string;
  size: string;
  product_type: string;
  order_id: string;
}

let lastHealthCheck = 0;
let lastHealthResult = false;
const HEALTH_TTL_MS = 30_000;

// Strip Metanoia brand prefix + flag + origin tags from product name so the
// label shows the actual product type (襯衫 / 外套 / 針織 ...).
export function deriveProductType(productName: string): string {
  if (!productName) return '';
  let s = productName;
  s = s.replace(/【[^】]*】/g, '');                     // 【Metanoia】
  s = s.replace(/🇰🇷|🇯🇵|🇰🇵/g, '');                   // flag emojis
  s = s.replace(/韓製|韓國設計|日製|日本設計/g, '');
  s = s.replace(/\s+/g, ' ').trim();
  if (s.length > 10) s = s.slice(0, 10);
  return s;
}

export async function isPrintBridgeAvailable(force = false): Promise<boolean> {
  const now = Date.now();
  if (!force && now - lastHealthCheck < HEALTH_TTL_MS) return lastHealthResult;
  lastHealthCheck = now;
  try {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 1500);
    const res = await fetch(`${BRIDGE_URL}/health`, { signal: ctrl.signal });
    clearTimeout(timer);
    lastHealthResult = res.ok;
  } catch {
    lastHealthResult = false;
  }
  return lastHealthResult;
}

export async function printItemLabel(payload: ItemLabelPayload): Promise<void> {
  const res = await fetch(`${BRIDGE_URL}/print/item-label`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`print bridge error (${res.status}): ${body}`);
  }
}

// Print N copies of the same label (one per quantity).
export async function printItemLabels(
  payload: ItemLabelPayload,
  copies: number,
): Promise<void> {
  const n = Math.max(1, Math.min(copies, 10));  // safety cap
  for (let i = 0; i < n; i++) {
    await printItemLabel(payload);
  }
}
